<script>
	import { link } from "svelte-navigator";
	import { Modal } from "../stores/modal";
	import ProductDetails from "./modals/ProductDetails.svelte";
	import ListItem from "./products/ListItem.svelte";
	import {onMount} from 'svelte'
	import Filters from '../stores/filters';
	let all_products = [];
	let products = [];
	let mainMenuItems = [];
	onMount(() => {
		fetch('https://crm.lamara.in/products/products/productslist').then(res => res.json()).then(res => {
			products = res.data;
			all_products = [...products];
		})
		fetch('https://crm.lamara.in/products/products/apiitemlist').then(res => res.json()).then(res => {
			mainMenuItems = res.data;
		})
	})
	Filters.subscribe(f => {
		products = [];
		if(f.filters_list.length || f.product_sizes.length){
			fetch("https://crm.lamara.in/products/products/productsbyfilters",{
				method: "POST",
				body: JSON.stringify({
					data: f
				})
			}).then(res => res.json()).then(res => {
				if(!res.error)
				products = res.data;
				else
				products = [];
			})
		}else{
			products = all_products;
		}
	})
</script>
<section id="products" class="products">
	<div class="container">
		<!-- <div class="section-title text-center">
			<h2>Cakes!</h2>
			<p>Lorem ipsum dolor sit amet, consectetur adipis</p>
		</div> -->
		<h2 class="section-title text-capitalize">
			Menu Categories
		</h2>
		<div class="row show-case-items">
			<!-- old code  -->
			<!-- {#each products as  product}
				<ListItem product={product}/>
			{:else}
				Oops! No cakes found!
			{/each} -->
			<!-- new ui -->
			{#if mainMenuItems && mainMenuItems.length}
				{#each mainMenuItems as cat}
					<div class="col-6 col-md-4">
						<a class="item-box" href="/cat/{cat.id}" use:link>
							<div class="product text-center">
								<img src={cat.item_img && cat.item_img != 'N/A' ? cat.item_img : '/images/ccakes.jpeg'} class="img-responsive">
							</div>
							<div class="caption">
								<h5>
									{cat.name} 
								</h5>
							</div>
						</a>
					</div>
				{/each}
			{:else}
				<div class="col-6 col-md-4">
					<a class="item-box" href="/celebration-cakes" use:link>
						<div class="product text-center">
							<img src="/images/ccakes.jpeg" class="img-responsive">
						</div>
						<div class="caption">
							<h5>
								Premium Celebration Cakes 
							</h5>
						</div>
					</a>
				</div>
				<div class="col-6 col-md-4">
					<a class="item-box" href="brownies" use:link>
						<div class="product text-center">
							<img src="/images/choco.jpg" class="img-responsive">
						</div>
						<div class="caption">
							<h5>
								Brownies
							</h5>
						</div>
					</a>
				</div>
				<div class="col-6 col-md-4">
					<a class="item-box" href="turkish" use:link>
						<div class="product text-center">
							<img src="/images/dry-pista.png" class="img-responsive">
						</div>
						<div class="caption">
							<h5>
								Turkish Blondies
							</h5>
						</div>
					</a>
				</div>
			{/if}
		</div>
</section>
<style lang="scss">
	.section-title {
		padding: 25px 0 0px 0;
		margin-bottom: 0;
		// font-family: 'Arizonia', cursive;
		font-family: var(--primary-font);
		color: #434343;
		font-size: 22px;
		// font-style: italic;
		text-align: center;
	}

	.product {
		position: relative;
		border: 4px solid rgba(247, 195, 114, 0.7);
		overflow: hidden;
		border-radius: 12px 12px 0 0;
		position: relative;
		padding: 0;
	}

	.product::before {
		content: '';
		position: absolute;
		left: 3px;
		right: 3px;
		bottom: 3px;
		top: 3px;
		border: 2px solid rgba(247, 195, 114, 0.5);
		z-index: 9;
		border-radius: 8px;
	}

	.caption {
		bottom: 3px;
		left: 3px;
		right: 3px;
		background: rgba(166, 144, 107, 0.9);
		border-radius: 0 0 8px 8px;
		margin-bottom: 40px;
		h5 {
			padding: 6px 4px;
			font-family: var(--primary-font);
			color: #434343;
			margin: 0;
			font-size: 17px;
			text-transform: uppercase;
			position: relative;
			min-height: 48px;
			display: flex;
			align-items: center;
			justify-content: center;
			text-align: center;
			flex-flow: column;

			span {
				font-size: 14px;
			}
		}
	}
	.section-title {
		margin-bottom: 24px;
	}

	@media only screen and (min-width: 300px) and (max-width: 650px) {
		.caption {
			h5 {
				span {
					font-size: 12px;
				}
			}
		}
	}
	
</style>